// packages
import React, { useState, createContext, Dispatch, SetStateAction } from "react";

// types
type ActionProps = {
  elementOuterHTML: string;
  parentElement: HTMLElement;
  previousElementSibling: HTMLElement;
  nextElementSibling: HTMLElement;
};
type ContextProps = {
  page: number;
  incrementPage(): void;
  decrementPage(): void;
  search: string;
  setSearch: Dispatch<SetStateAction<string>>;
  setPage: Dispatch<SetStateAction<number>>;
  disableNextButton: boolean;
  setDisableNextButton: Dispatch<SetStateAction<boolean>>;
};

// variables
// @ts-ignore
const DataTableContext = createContext<ContextProps>();

const DataTableContextProvider = ({ children }: { children: Readonly<React.ReactNode> }) => {
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const [disableNextButton, setDisableNextButton] = useState(false);

  const incrementPage = () => {
    setPage(prev => prev + 1);
  };

  const decrementPage = () => {
    setPage(prev => prev - 1);
  };

  return (
    <DataTableContext.Provider
      value={{
        page,
        incrementPage,
        decrementPage,
        search,
        setSearch,
        setPage,
        disableNextButton,
        setDisableNextButton,
      }}
    >
      {children}
    </DataTableContext.Provider>
  );
};

export { DataTableContext, DataTableContextProvider };
